export const HOME_ROUTE = '/';
export const ONBOARDING_ROUTE = '/onboarding'
